// composables/useReturnToMenu.js
import { useRouter } from 'vue-router'
import useOrderStore from '@client/js/store/order'
import useCartStore from '@client/js/store/cart'

export function useReturnToMenu(emit) {
  const router = useRouter()
  const orderStore = useOrderStore()
  const cartStore = useCartStore()

  const returnToMenu = () => {
    orderStore.paymentStatus = ''
    orderStore.paymentMessage = ''
    if (emit) emit('close');
    cartStore.clear()
    router.push('/')
  }

  return { returnToMenu }
}